import { GridColDef } from '@mui/x-data-grid';

/** Columns kept visible on compact screens unless explicitly hidden */
export const PRIORITY_FIELDS = new Set([
  '__sno',
  'name',
  'title',
  'code',
  'status',
  'partnerStatus',
  'isActive',
  'isOpen',
  'rating',
  'actions',
  'email',
  'phone',
  'rideNumber',
  'orderNumber',
  'bookingNumber',
  'viewTrip',
  'paymentMethod',
  'total',
  'createdAt',
  'closedAt',
  'eventAt',
  'partner',
  'customerId',
  'restaurantId',
  'image',
  'maxWeightKg',
  'dimensions',
  'zoneIds',
  'categoryId',
  'specialHandling',
  'weightKg',
]);

export type ResponsiveGridColDef = GridColDef & {
  hideOnMobile?: boolean;
  hideOnTablet?: boolean;
};

export function buildCompactColumnVisibility(
  columns: GridColDef[],
  level: 'mobile' | 'tablet' | false,
): Record<string, boolean> {
  if (!level) return {};

  const model: Record<string, boolean> = {};
  for (const col of columns) {
    if (!col.field) continue;
    const rcol = col as ResponsiveGridColDef;

    if (rcol.hideOnMobile && level === 'mobile') {
      model[col.field] = false;
      continue;
    }
    if (rcol.hideOnTablet && (level === 'mobile' || level === 'tablet')) {
      model[col.field] = false;
      continue;
    }
    if (PRIORITY_FIELDS.has(col.field)) continue;

    const w = typeof col.width === 'number' ? col.width : 0;
    const minW = typeof col.minWidth === 'number' ? col.minWidth : 0;
    const isWide = w > 120 || minW > 120;

    if (level === 'mobile' && isWide) model[col.field] = false;
    else if (level === 'tablet' && (w > 160 || minW > 160)) model[col.field] = false;
  }
  return model;
}

export const responsiveDataGridSx = {
  width: '100%',
  minWidth: 0,
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& .MuiDataGrid-root': {
    minWidth: { xs: 520, sm: '100%' },
  },
} as const;
